export default "__VITE_ASSET__DnYoAd1f__"